(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/match-info-components/assets/javascripts/favorites.js') >= 0) return;  svs.modules.push('/components/sportinfo/match-info-components/assets/javascripts/favorites.js');
"use strict";


const {
  useSelector
} = ReactRedux;
const {
  selectEventStatisticCurrentValueByType
} = svs.components.sportinfo.matchInfoRedux.selectors;
const {
  EventTypeField,
  AllKnownOutcomesDescription,
  EventTypeId
} = svs.components.sportinfo.common.constants;
const {
  createEventStatisticsKey
} = svs.components.sportinfo.common.helpers;
const {
  StatisticSection
} = svs.components.sportinfo.matchInfoComponents;
const Favorites = _ref => {
  var _betEvent$eventTypeId;
  let {
    matchId,
    betEvent
  } = _ref;
  const eventTypeId = (_betEvent$eventTypeId = betEvent.eventTypeId) !== null && _betEvent$eventTypeId !== void 0 ? _betEvent$eventTypeId : EventTypeId.EVENT_1X2;
  const matchEventTypeId = createEventStatisticsKey({
    matchId,
    eventTypeId,
    periodNumber: betEvent.periodNumber,
    eventNumber: betEvent.eventNumber
  });
  const favourites = useSelector(state => selectEventStatisticCurrentValueByType(state, matchEventTypeId, EventTypeField.Favourites));
  if (favourites.length === 0 || favourites.filter(el => Boolean(el)).length === 0) {
    return null;
  }
  let gridTemplateColumns = '';
  const valueColumns = [];
  const valueTitleColumns = [];
  favourites.forEach((v, i) => {
    const floatValue = v ? parseFloat(v) : 0;
    const frValue = Math.ceil(floatValue);
    const keypart = "".concat(i, "_").concat(frValue);
    gridTemplateColumns += "".concat(frValue, "fr ");
    valueColumns[i] = React.createElement("div", {
      className: "match-info-favorites-bar",
      key: "value_".concat(keypart)
    }, Math.round(floatValue), "%");
    let align;
    if (i === 0) {
      align = 'align-left';
    } else if (i === favourites.length - 1) {
      align = 'align-right';
    } else {
      align = 'align-center';
    }
    valueTitleColumns[i] = React.createElement("div", {
      className: align,
      key: "title_".concat(keypart)
    }, AllKnownOutcomesDescription[eventTypeId][i]);
  });
  return React.createElement(StatisticSection, {
    heading: "Favoritskap utifr\xE5n odds"
  }, React.createElement("div", {
    className: "match-info-favorites",
    style: {
      gridTemplateColumns: gridTemplateColumns.trim()
    }
  }, valueColumns, valueTitleColumns));
};
setGlobal('svs.components.sportinfo.matchInfoComponents.Favorites', Favorites);

 })(window);